<template>
  <v-dialog v-model="dialogOpen" :persistent="true" max-width="600px">
    <v-form>
      <v-card>
        <v-card-title>
          <h4><v-icon>mdi-folder</v-icon>Auftrag</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="name"
            label="Bezeichnung"
            required
            :rules="rules"
          />
          <v-text-field
            v-model="patternNumber"
            label="Ansatz"
            required
            :rules="rules"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="default" text @click="close" :disabled="actionsDisabled">Abbrechen</v-btn>
          <v-btn v-if="isExistingOrder && order.isActive" color="error" class="white--text" @click="setInactive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye-off</v-icon> Deaktivieren
          </v-btn>
          <v-btn v-else-if="isExistingOrder" color="success" class="white--text" @click="setActive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye</v-icon> Aktivieren
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid || actionsDisabled" :loading="isSaving">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import timeparkApi from "@/timeparkApi";
const productsApi = timeparkApi.productsApi;

export default {
  name: 'OrderDialog',
  props: {
    open: Boolean,
    order: Object,
    productId: String,
  },
  computed: {
    dialogOpen: {
      get() {
        return this.open;
      },
      set(v) {
        this.$emit('update:open', v);
      }
    },
    isChangingActive() {
      return this.runningOperation === 'changeActive';
    },
    isSaving() {
      return this.runningOperation === 'save';
    },
    actionsDisabled() {
      return !!this.runningOperation;
    },
    valid() {
      return !!this.name && !! this.patternNumber;
    },
    isExistingOrder() {
      return this.order && this.order.id;
    }
  },
  watch: {
    order: {
      deep: true,
      handler: 'updateData'
    }
  },
  methods: {
    async setInactive() {
      this.runningOperation = 'changeActive';

      await productsApi.deactivateOrder(this.productId, this.order.id);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    async setActive() {
      this.runningOperation = 'changeActive';

      await productsApi.reactivateOrder(this.productId, this.order.id);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    async save() {
      const order = {
        id: this.order ? this.order.id : null,
        number: this.number,
        patternNumber: this.patternNumber,
        name: this.name,
      };
      const apiOperation = order.id ?
          productsApi.editOrder :
          productsApi.createOrder;
      this.runningOperation = 'save';

      await apiOperation(this.productId, order);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    close() {
      this.updateData(null);
      this.$emit('close');
    },
    updateData(data) {
      this.name = data ? data.name : '';
      this.number = data ? data.number : null;
      this.patternNumber = data ? data.patternNumber : null;
    },
  },
  data() {
    return {
      name: '',
      number: null,
      patternNumber: null,
      rules: [val => !!val || 'Dieses Feld darf nicht leer sein'],
      runningOperation: null,
    };
  },
};
</script>
